<template>
  <BaseDropdown class="w-full group" button-class="flex items-center w-full py-3 px-4">
    <template v-slot:button>
      <div class="w-2 h-2 rounded-full mr-2 flex-shrink-0" :class="statusColor"></div>
      <span class="font-semibold text-gray-800 w-24 text-left overflow-hidden whitespace-no-wrap truncate">{{ label }}</span>
      <BaseIcon name="chevron-down" class="ml-1 text-gray-100 lg-only:hidden group-hover:text-gray-600" />
    </template>
    <div class="text-sm text-gray-500 px-2">Dit contact is een ...?</div>
    <button
      class="dropdown-item w-48 flex items-center justify-between"
      v-for="status in $store.state.settings.statuses"
      :key="status.id"
      @click="save(status)"
    >
      {{status.name}}
      <span
        v-if="status.id == contact.status_id"
        class="w-2 h-2 rounded-full bg-gray-300"
      ></span>
    </button>
    <button class="dropdown-item w-48 flex items-center justify-between" @click="save({})">
      Geen soort
      <span v-if="!contact.status_id" class="w-2 h-2 rounded-full bg-gray-300"></span>
    </button>
  </BaseDropdown>
</template>

<script>
import { patch } from "@/api.js";

export default {
  computed: {
    contact() {
      return this.$store.state.contact;
    },

    label() {
      return this.contact.status ? this.contact.status.name : "Geen soort";
    },

    statusColor() {
      let status = this.contact.status || {};

      if (status.identifier === "customer") return "bg-green-400";

      return "bg-gray-300";
    }
  },

  methods: {
    save(status) {
      let data = { status_id: status.id };
      patch(`/contacts/${this.contact.id}/status`, data).then(response => {
        this.$store.commit("SET_CONTACT", response.data);
      });
    }
  }
};
</script>
